import React, { useContext, useState } from "react";
import logo from "../../../assets/img/logo.png";
import AuthContext from "../../../Context/Auth/AuthContext";
import {
  IconButton,
  Toolbar,
  Typography,
  Box,
  Avatar,
  alpha,
  Chip,
  keyframes,
} from "@mui/material";
import { Menu, NotificationsActive } from "@mui/icons-material";
import NotificactionsButtons from "./NotificactionsButtons";
import { withRouter } from "react-router-dom";

const ringBell = keyframes`
  0%, 100% { transform: rotate(0deg); }
  8% { transform: rotate(18deg); }
  16% { transform: rotate(-16deg); }
  24% { transform: rotate(14deg); }
  32% { transform: rotate(-10deg); }
  40% { transform: rotate(6deg); }
  48% { transform: rotate(-3deg); }
  56% { transform: rotate(0deg); }
`;

const pulseGlow = keyframes`
  0%, 100% {
    box-shadow: 0 4px 24px rgba(0,0,0,0.2);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 6px 32px rgba(0,0,0,0.35);
    transform: scale(1.03);
  }
`;

const slideInBounce = keyframes`
  0% { opacity: 0; transform: translateX(-20px) scale(0.8); }
  60% { opacity: 1; transform: translateX(4px) scale(1.04); }
  80% { transform: translateX(-2px) scale(0.98); }
  100% { opacity: 1; transform: translateX(0) scale(1); }
`;

const textPop = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.08); }
`;

const NavbarDesktop = (props) => {
  const {
    handleDrawerClose,
    handleDrawerOpen,
    open,
    buscador,
    setbuscador,
  } = props;
  const { usuario } = useContext(AuthContext);
  const [totalNoLeidas, setTotalNoLeidas] = useState(0);

  return (
    <Toolbar
      sx={(theme) => ({
        background: totalNoLeidas > 0
          ? `linear-gradient(to right, ${alpha(theme.palette.primary.main, 0.12)}, ${alpha(theme.palette.primary.main, 0.05)})`
          : `linear-gradient(to right, ${alpha(theme.palette.background.paper, 0.97)}, ${theme.palette.background.paper})`,
        borderBottom: `1px solid ${alpha(
          totalNoLeidas > 0 ? theme.palette.primary.main : theme.palette.divider,
          totalNoLeidas > 0 ? 0.3 : 0.08,
        )}`,
        backdropFilter: "blur(8px)",
        transition: "background 0.4s ease, border-color 0.4s ease",
      })}
    >
      <IconButton
        aria-label="open drawer"
        edge="start"
        onClick={() => (open ? handleDrawerClose() : handleDrawerOpen())}
        sx={{
          mr: 2,
          borderRadius: 2,
          color: (t) =>
            totalNoLeidas > 0
              ? t.palette.primary.contrastText
              : t.palette.text.primary,
          "&:hover": {
            backgroundColor: (theme) =>
              alpha(theme.palette.primary.main, 0.08),
          },
        }}
      >
        <Menu />
      </IconButton>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Box display="flex" justifyContent="center" alignItems="center">
          <Avatar
            src={usuario.logo}
            sx={{
              width: 40,
              height: 40,
              cursor: "pointer",
              border: (theme) =>
                `2px solid ${alpha(theme.palette.primary.main, 0.15)}`,
              transition: "border-color 0.2s",
              "&:hover": {
                border: (theme) =>
                  `2px solid ${alpha(theme.palette.primary.main, 0.4)}`,
              },
            }}
            onClick={() => props.history.push("/Contable/Dashboard")}
          />
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              fontSize: "1.1rem",
              ml: 1.5,
              mr: 2,
              color: (t) =>
                totalNoLeidas > 0
                  ? t.palette.primary.contrastText
                  : t.palette.text.primary,
              letterSpacing: -0.3,
            }}
          >
            {usuario.nomComercial}
          </Typography>
        </Box>

        {totalNoLeidas > 0 && (
          <Box
            sx={{
              animation: `${slideInBounce} 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)`,
              display: "flex",
              alignItems: "center",
              gap: 1.2,
              backgroundColor: (t) => t.palette.primary.main,
              color: (t) => t.palette.primary.contrastText,
              py: 1,
              px: 2,
              borderRadius: 50,
              animationDuration: "0.6s, 2s",
              animationName: `${slideInBounce}, ${pulseGlow}`,
              animationIterationCount: "1, infinite",
              animationTimingFunction: "cubic-bezier(0.34,1.56,0.64,1), ease-in-out",
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            <NotificationsActive
              sx={{
                fontSize: "1.4rem",
                animation: `${ringBell} 2s ease-in-out infinite`,
              }}
            />
            <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: "1.05rem",
                  color: (t) => t.palette.primary.contrastText,
                  animation: `${textPop} 2.5s ease-in-out infinite`,
                  letterSpacing: -0.5,
                }}
              >
                {totalNoLeidas} nueva{totalNoLeidas > 1 ? "s" : ""}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "0.72rem",
                  color: (t) => alpha(t.palette.primary.contrastText, 0.85),
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                }}
              >
                notificacion{totalNoLeidas > 1 ? "es" : ""}
              </Typography>
            </Box>
          </Box>
        )}

        <Box display="flex" justifyContent="center" alignItems="center">
          <NotificactionsButtons onNotificacionesChange={setTotalNoLeidas} />
        </Box>
      </Box>
    </Toolbar>
  );
};

export default withRouter(NavbarDesktop);
